import Reducer from 'modules/Referral/PayoutProfiles/Invoices/reducer'
import Invoices from 'modules/Referral/PayoutProfiles/Invoices/Invoices'

export { Reducer as Reducer }

export default Invoices
